import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Save, Calendar, FileText, MapPin, ExternalLink, Image, Users, StickyNote, Upload } from 'lucide-react';
import ImageGalleryModal from './ImageGallery/ImageGalleryModal';
import axios from "axios";
import DatePicker from "react-datepicker";
import { baseUrl } from '../../Constants';
import MyDatePicker from './MyDatePicker';

const images = [
  "images/Home/upcoming-events-latest-brand.png"
];

// Validation functions
const validateSectionSubtext = (value) => {
  if (!value) return 'Section subtext is required';
  if (value.length < 10) return 'Section subtext must be at least 10 characters';
  if (value.length > 300) return 'Section subtext must be less than 300 characters';
  return true;
};

const validateTitle = (value) => {
  if (!value) return 'Title is required';
  if (value.length < 3) return 'Title must be at least 3 characters';
  if (value.length > 150) return 'Title must be less than 150 characters';
  return true;
};

const validateDate = (value) => {
  if (!value) return 'Date is required';
  return true;
};

const validateDescription = (value) => {
  if (!value) return 'Description is required';
  if (value.length < 5) return 'Description must be at least 5 characters';
  if (value.length > 300) return 'Description must be less than 300 characters';
  return true;
};

const validateContent = (value) => {
  if (!value) return 'Content is required';
  if (value.length < 20) return 'Content must be at least 20 characters';
  if (value.length > 500) return 'Content must be less than 500 characters';
  return true;
};

const validateWhere = (value) => {
  if (!value) return 'Location is required';
  if (value.length < 3) return 'Location must be at least 3 characters';
  if (value.length > 100) return 'Location must be less than 100 characters';
  return true;
};

const validateImageUrl = (value) => {
  if (!value) return 'Image URL is required';
  return true;
};

const validateExplore = (value) => {
  if (!value) return 'Explore content is required';
  return true;
};

const validateJoinEvent = (value) => {
  // if (!value) return 'Join event URL is required';
  if(value){

    try {
      new URL(value);
      return true;
    } catch {
      return 'Please enter a valid URL';
    }
  }
};

const axiosPostCall = async (data, getUpcomingEvents) => {
  try {
    const res = await axios.post(`${baseUrl}/addupcomingevent`, data,
      {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      }
    );
    getUpcomingEvents();
  } catch (err) {
    console.error(err);
  }
};

const AddUpcomingEvents = ({
  onSubmit = (data) => {
    console.log('Form submitted:', data);
    axiosPostCall(data, getUpcomingEvents);
  },
  initialData,
  setaddUpcomingEventPopup,
  getUpcomingEvents
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
    watch,
    setValue
  } = useForm({
    defaultValues: initialData || {
      // sectionsubtext: '',
      title: '',
      date: null,
      description: '',
      content: '',
      where: '',
      imageUrl: '',
      joinevent: '',
      note: '',
      explore_0: '',
      date_0: null,
      explore_1: '',
      date_1: null,
      explore_2: '',
      date_2: null,
      explore_3: '',
      date_3: null,
      explore_4: '',
      date_4: null,
      explore_5: '',
      date_5: null,
      title_0: '',
      title_1: '',
      title_2: '',
      title_3: '',
      title_4: '',
      title_5: '',

    }
  });

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [linkType, setLinkType] = useState('joinevent');
  const [exploreLinks, setExploreLinks] = useState([{}]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDatesArray, setSelectedDatesArray] = useState([null, null, null, null, null, null]);

  // const watchedSectionSubtext = watch('sectionsubtext', '');
  const watchedContent = watch('content', '');
  const watchedDescription = watch('description', '');

  const onFormSubmit = async (data) => {
    try {
      if (linkType === 'explore') {
        const exploreArray = Object.keys(data)
          .filter((key) => key.startsWith('explore_'))
          .map((key) => data[key])
          .filter((link) => link?.trim() !== '');

        data.explore = exploreArray;
        delete data.joinevent;
        console.log("exploreArray", exploreArray);
      } else {
        delete data.explore;
        Object.keys(data).forEach(key => {
          if (key.startsWith('explore_')) delete data[key];
        });
      }
      console.log("upcom data", data);
      await onSubmit(data);
    } catch (error) {
      console.error('Error submitting form:', error);
    }
    setaddUpcomingEventPopup(false);
  };

  const handleImageSelect = (src) => {
    setSelectedImage(src);
    setValue('imageUrl', src);
  };

  return (
    <>
      <div className="form-container">
        <div className="form-header">
          <h2 className="form-title">Add Upcoming Event</h2>
          <div className="form-description">Create a new upcoming event entry with all required details.</div>
        </div>

        <form onSubmit={handleSubmit(onFormSubmit)} className="form">
          <div className="split-form">
          <div className="form-column">
          {/* Section Subtext */}
          {/* <div className="field-group">
            <label htmlFor="sectionsubtext" className="field-label-with-counter">
              <span className="field-label">
                <FileText className="field-icon" />
                Section Subtext
              </span>
              <span className="character-counter">
                {watchedSectionSubtext.length}/300
              </span>
            </label>
            <textarea
              {...register('sectionsubtext', { validate: validateSectionSubtext })}
              id="sectionsubtext"
              rows={1}
              placeholder="Join the webinar to enhance delivery capabilities by exploring key tools, methodologies, GenAI, and emerging trends."
              className={`field-textarea ${errors.sectionsubtext ? 'error' : ''}`}
            />
            {errors.sectionsubtext && (
              <div className="error-message">
                <span className="error-dot"></span>
                {errors.sectionsubtext.message}
              </div>
            )}
          </div> */}

          {/* Title */}
          <div className="field-group">
            <label htmlFor="title" className="field-label">
              <FileText className="field-icon" />
              Event Title
            </label>
            <input
              {...register('title', { validate: validateTitle })}
              type="text"
              id="title"
              placeholder="e.g., Delivery Foundation Academy (DFA) 4.0"
              className={`field-input ${errors.title ? 'error' : ''}`}
              aria-label="title"
            />
            {errors.title && (
              <div className="error-message">
                <span className="error-dot"></span>
                {errors.title.message}
              </div>
            )}
          </div>

          {/* Description */}
          <div className="field-group">
            <label htmlFor="description" className="field-label-with-counter">
              <span className="field-label">
                <FileText className="field-icon" />
                Short Description
              </span>
              <span className="character-counter">
                {watchedDescription.length}/300
              </span>
            </label>
            <input
              {...register('description', { validate: validateDescription })}
              type="text"
              id="description"
              placeholder="e.g., Final event of the month, be there!"
              className={`field-input ${errors.description ? 'error' : ''}`}
              aria-label="description"
            />
            {errors.description && (
              <div className="error-message">
                <span className="error-dot"></span>
                {errors.description.message}
              </div>
            )}
          </div>

          {/* Content */}
          <div className="field-group">
            <label htmlFor="content" className="field-label-with-counter">
              <span className="field-label">
                <FileText className="field-icon" />
                Event Content
              </span>
              <span className="character-counter">
                {watchedContent.length}/500
              </span>
            </label>
            <textarea
              // {...register('content', { validate: validateContent })}
              {...register('content')}
              id="content"
              rows={2}
              placeholder="DFA 4.0 delivers comprehensive training for all experience levels, enhancing delivery capabilities through key tools..."
              className={`field-textarea ${errors.content ? 'error' : ''}`}
            />
            {errors.content && (
              <div className="error-message">
                <span className="error-dot"></span>
                {errors.content.message}
              </div>
            )}
          </div>

          {/* Where */}
          <div className="field-group">
            <label htmlFor="where" className="field-label">
              <MapPin className="field-icon" />
              Event Location
            </label>
            <input
              // {...register('where', { validate: validateWhere })}
              {...register('where')}
              type="text"
              id="where"
              placeholder="e.g., Lorem ipsum dolor sit amet"
              className={`field-input ${errors.where ? 'error' : ''}`}
              aria-label="location"
            />
            {errors.where && (
              <div className="error-message">
                <span className="error-dot"></span>
                {errors.where.message}
              </div>
            )}
          </div>

                    {/* Image Gallery */}
          <div className="field-group">
            <label htmlFor="imageUrl" className="field-label">
              <Upload className="field-icon" />
              Image Path
            </label>
            <div>
              {selectedImage && (
                <img src={selectedImage} alt="Selected" style={{ width: 100 }} />
              )}
              <button
                className="choose-image-btn"
                type="button"
                onClick={() => setIsModalOpen(true)}
              >
                Choose Image
              </button>
            </div>
            
              {errors.imageUrl && (
                <div className="error-message">
                  <span className="error-dot"></span>
                  {errors.imageUrl.message}
                </div>
              )}
          </div>
          
          </div>
          <div className="form-column">
          {/* Image URL */}
          {/* <div className="field-group">
            <label htmlFor="imageUrl" className="field-label">
              <Image className="field-icon" />
              Image URL
            </label>
            <input
              {...register('imageUrl', { validate: validateImageUrl })}
              type="text"
              id="imageUrl"
              placeholder="e.g., images/Home/upcoming-events-latest-updated.png"
              className={`field-input ${errors.imageUrl ? 'error' : ''}`}
              aria-label="image"
            />
            {errors.imageUrl && (
              <div className="error-message">
                <span className="error-dot"></span>
                {errors.imageUrl.message}
              </div>
            )}
          </div> */}

          {/* Link Type Selector */}
          <div className="field-group">
            <label className="field-label">
              <Users className="field-icon" />
              Select Link Type
            </label>
            <div className="radio-group">
              <label>
                <input style={{marginInline:'8px'}}
                  type="radio"
                  value="joinevent"
                  checked={linkType === 'joinevent'}
                  onChange={() => setLinkType('joinevent')}
                />
                Event Joining Link
              </label>
              <label style={{ marginLeft: "20px" }}>
                <input style={{marginInline:'8px'}}
                  type="radio"
                  value="explore"
                  checked={linkType === 'explore'}
                  onChange={() => setLinkType('explore')}
                />
                Explore Events Links
              </label>
            </div>
          </div>

          {/* Conditional Rendering */}
          {linkType === 'joinevent' && (
            <div style={{display: 'flex'}}>
            <div className="field-group" style={{width:'85%', marginRight:'8px'}}>
              <label htmlFor="joinevent" className="field-label">
                <Users className="field-icon" />
                Join Event URL
              </label>
              <input
                {...register('joinevent', { validate: validateJoinEvent })}
                type="url"
                id="joinevent"
                placeholder="https://teams.microsoft.com/l/meetup-join/..."
                className={`field-input ${errors.joinevent ? 'error' : ''}`}
                aria-label="link"
              />
                  {errors.joinevent && (
                    <div className="error-message">
                      <span className="error-dot"></span>
                      {errors.joinevent.message}
                    </div>
                  )}
            </div>
              {/* Date */}
              <div className="field-group">
                <label htmlFor="date" className="field-label">
                  <Calendar className="field-icon" />
                  Event Dates
                </label>
                    <DatePicker
                      // {...register('date', { validate: validateDate })}
                      {...register('date')}
                      id="date"
                      className={`field-textarea ${errors.date ? 'error' : ''}`}
                      selected={selectedDate}
                      onChange={(date) => {setSelectedDate(date); setValue(`date`, date);}}
                      // showMonthDropdown
                      // showYearDropdown
                      dropdownMode="select"
                      dateFormat="yyyy/MM/dd"
                      placeholderText="2025/09/15"
                    />
                {/* <textarea
                  {...register('date', { validate: validateDate })}
                  id="date"
                  rows={1}
                  placeholder="2025-09-15"
                  className={`field-textarea ${errors.date ? 'error' : ''}`}
                /> */}
                {errors.date && (
                  <div className="error-message">
                    <span className="error-dot"></span>
                    {errors.date.message}
                  </div>
                )}
              </div>
              </div>
          )}

          {linkType === 'explore' && (
            <>
              {exploreLinks.map((_, index) => (
                <div key={index} style={{display: 'flex'}}>
                    {/* Title */}
                    <div className="field-group" style={{width:'40%',marginRight:'8px'}}>
                      <label htmlFor="title" className="field-label">
                        <FileText className="field-icon" />
                         Portal Title {exploreLinks.length > 1 ? index + 1 : ''}
                      </label>
                      <input
                        {...register(`title_${index}`)}
                        id={`title-${index}`}
                        type="text"
                        placeholder="Delivery Foundation Academy (DFA) 4.0"
                        className={`field-input ${errors[`title_${index}`] ? 'error' : ''}`}
                        aria-label="title"
                      />
                  {errors[`title_${index}`] && (
                    <div className="error-message">
                      <span className="error-dot"></span>
                      {errors[`title_${index}`].message}
                    </div>
                  )}
                    </div>
                <div className="field-group" style={{width:'85%', marginRight:'8px'}}>
                  <label htmlFor={`explore-${index}`} className="field-label">
                    <ExternalLink className="field-icon" />
                    Explore Link {exploreLinks.length > 1 ? index + 1 : ''}
                  </label>
                  <textarea
                    // {...register(`explore_${index}`, { validate: validateExplore })}
                    {...register(`explore_${index}`)}
                    id={`explore-${index}`}
                    rows={1}
                    placeholder="https://example.com"
                    className={`field-textarea ${errors[`explore_${index}`] ? 'error' : ''}`}
                  />
                  {errors[`explore_${index}`] && (
                    <div className="error-message">
                      <span className="error-dot"></span>
                      {errors[`explore_${index}`].message}
                    </div>
                  )}
                  </div>
                  {/* Date */}
                  <div className="field-group">
                    <label htmlFor="date" className="field-label">
                      <Calendar className="field-icon" />
                      Event Dates
                    </label>
                    <DatePicker
                      // {...register(`date_${index}`)}
                      id={`date-${index}`}
                      className={`field-textarea`}
                      selected={selectedDatesArray[index]}
                      onChange={(date) => {setValue(`date_${index}`, date); 
                        setSelectedDatesArray(prevArray =>
                          prevArray.map((item, i) => i === index ? date : item)
                        );
                      }}
                      dateFormat="yyyy/MM/dd"
                      placeholderText="2025/09/15"
                    />
                  </div>
                </div>
              ))}
              {exploreLinks.length < 6 && (
                <div>
                  <button
                    type="button"
                    className="choose-image-btn"
                    onClick={() => setExploreLinks([...exploreLinks, ''])}
                  >
                    + Add
                  </button>
                </div>
              )}
            </>
          )}

          {/* Note */}
          <div className="field-group">
            <label htmlFor="note" className="field-label">
              <StickyNote className="field-icon" />
              Additional Notes (Optional)
            </label>
            <textarea
              {...register('note')}
              id="note"
              rows={1}
              placeholder="Any additional notes or comments..."
              className="field-textarea"
            />
          </div>

          <ImageGalleryModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            onSelect={handleImageSelect}
            images={images}
          />
                    </div>
          </div>

          {/* Buttons */}
          <div className="button-group-addevent">
            <button
              type="submit"
              disabled={isSubmitting}
              className="submit-button"
            >
              {isSubmitting ? (
                <>
                  <div className="loading-spinner"></div>
                  Saving...
                </>
              ) : (
                <>
                  <Save className="button-icon" />
                  Save Event
                </>
              )}
            </button>
            <button
              type="button"
              onClick={() => setaddUpcomingEventPopup(false)}
              className="cancel-button"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddUpcomingEvents;
